/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessFeatureFlagsDto } from '../models/BusinessFeatureFlagsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeatureFlagsService {
    /**
     * Business-scoped feature flags for the caller's current business
     * @returns BusinessFeatureFlagsDto
     * @throws ApiError
     */
    public static featureFlagsControllerBusinessV1(): CancelablePromise<BusinessFeatureFlagsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/feature-flags/business',
        });
    }
}
